module.exports = __webpack_public_path__ + "img/02_content_05@2x.cab60b1b.png";